import Route from "../../../router/Route";

import AnnotationsOverview from "@/modules/annotations/pages/AnnotationsOverview.vue";
import Base from "@/modules/annotations/pages/Base.vue";
import CategoriesOverview from "@/modules/annotations/pages/CategoriesOverview.vue";

export default new Route(
	"annotations",
	"/annotations",
	Base,
	[
		new Route("annotations.index", "annotations", AnnotationsOverview, [], {}),
		new Route(
			"annotations.categories",
			"categories",
			CategoriesOverview,
			[],
			{}
		),
	],
	{},
	(): string => {
		return `/annotations/annotations`;
	}
);
